import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCachedAnimationDetailsByName,
  selectSelectedAnimation,
  setCachedAnimationDetails,
  setSelectedAnimationDetails,
} from "../../../app/slices/AnimationsSlice";
import { selectCurrentOrganization } from "../../../app/slices/UserSlice";
import { RootState } from "../../../app/Store";
import { AnimationService } from "../../../services/AnimationService";

export default function useAnimationLibrary() {
  const dispatch = useDispatch();
  const selectedAnimation = useSelector(selectSelectedAnimation);
  const currentOrganization = useSelector(selectCurrentOrganization);
  const cachedDetails = useSelector((state: RootState) =>
    selectedAnimation
      ? selectCachedAnimationDetailsByName(state, selectedAnimation.name)
      : undefined
  );

  useEffect(() => {
    if (!selectedAnimation || !currentOrganization?.id) return;

    if (cachedDetails) {
      dispatch(setSelectedAnimationDetails(cachedDetails));
      return;
    }

    const loadAnimationDetails = async () => {
      const animationDetails = await AnimationService.GetAnimationDetails(
        currentOrganization.id,
        selectedAnimation.name
      );
      if (!animationDetails) return;

      dispatch(
        setCachedAnimationDetails({
          animationName: selectedAnimation.name,
          animationDetails,
        })
      );
      dispatch(setSelectedAnimationDetails(animationDetails));
    };

    loadAnimationDetails();
  }, [cachedDetails, currentOrganization?.id, dispatch, selectedAnimation]);
}
